import { staffClient } from "common/apis/staff";
import BasePageLayout from "components/Layout/BasePage";
import PagingTable, { EMPTY_PAGING_TABLE_RET } from "components/Table/Paging";
import PageTitle from "components/Title/Page";
import React, { useEffect } from "react";
import { columns } from "./config";

const CounselPage = () => {
    const fetchCounsels = async (page, limit) => {
        try {
            const params = {
                offset: (page - 1) * limit,
                limit
            }
            const ret = await staffClient.get("/counsel", { params });
            console.log("[fetchCounsels] ret", ret);
            return {
                data: ret.data?.data,
                total: ret.data?.meta?.total,
                page
            }
        } catch (e) {
            console.log("[fetchCounsels] error", e);
            return EMPTY_PAGING_TABLE_RET
        }
    }

    return (
        <BasePageLayout>
            <PageTitle>상담 관리</PageTitle>
            <PagingTable
                fetchData={fetchCounsels}
                columns={columns}
            />
        </BasePageLayout>
    )
}

export default CounselPage;
